import { createReducer, on } from '@ngrx/store';
import { driverLicenseActions } from '../driver_license.actions';

export interface DlExtractionState {
    state: 'pending' | 'loading' | 'loaded' | 'error';
}

export const initialState: DlExtractionState = { state: 'pending' };

export const dlExtractionReducer = createReducer(
    initialState,
    on(driverLicenseActions.extract, (state) => ({ ...state, state: 'loading' as const })),
    on(driverLicenseActions.extractSuccess, (state) => ({ ...state, state: 'loaded' as const })),
    on(driverLicenseActions.extractFail, (state) => ({ ...state, state: 'error' as const }))
);
